/**
 * EmptyState — delightful, bee-mascot-driven empty shelves.
 */

import React from 'react';
import { motion } from 'framer-motion';
import { MascotContainer, Button } from '@/components/site/primitives';
import { fadeUp } from '@/lib/motion';
import { EMPTY_STATE_MESSAGES } from './constants';
import { BOOKSHELF } from '@/constants/testIds';

import beeStand from '@/assets/bee-stand.png';
import beeFly from '@/assets/bee-fly.png';
import beeRead from '@/assets/bee-read.png';
import beeBack from '@/assets/bee-back.png';

const MASCOTS = {
  all: beeStand,
  tbr: beeFly,
  reading: beeRead,
  finished: beeStand,
  favorites: beeRead,
  search: beeBack,
  filter: beeBack,
};

export default function EmptyState({ type = 'all', onCTAClick, heading, subheading, cta }) {
  const message = EMPTY_STATE_MESSAGES[type] ?? EMPTY_STATE_MESSAGES.all;

  return (
    <div className="flex min-h-[380px] items-center justify-center py-10" data-testid={BOOKSHELF.emptyState}>
      <motion.div variants={fadeUp} initial="hidden" animate="show" className="mx-auto max-w-sm text-center">
        <MascotContainer src={MASCOTS[type] ?? beeStand} alt="" className="mx-auto h-28 w-28" />
        <h2 className="mt-4 font-display text-xl font-semibold text-ink">{heading ?? message.heading}</h2>
        <p className="mt-2 text-sm leading-relaxed text-subtle">{subheading ?? message.subheading}</p>
        {onCTAClick && (
          <Button variant="primary" icon={false} onClick={onCTAClick} className="mt-6">
            {cta ?? message.cta}
          </Button>
        )}
      </motion.div>
    </div>
  );
}
